<template>
<div>
    <div id="header">
        <div id="logo_div">
            <img src="../../static/img/logo_qvkan.png" alt="">
            <p style="float:right;margin-top:25px;font-size: 20px;display: inline-block;">中广在线(北京)网络科技有限公司</p>
        </div>
    </div>
    <div id="container" class="clearFix">
        <div class="lf left">
            <ul>
                <li v-for="(item,index) in arr" :key="item.index" @click="transChannel(item.id)" :class="[{'nav_li':true},{'active':item.id===checkChannelId}]">{{item.name}}</li>
            </ul>
        </div>
        <div class="ri left">
            <ul>
                <li class="ri_li" v-for="item1 in brr" :key="item1.index">
                    <a :href="item1.clickUrl">
                    <div class="clearFix">
                        <div class="img_div left">
                            <img :src="item1.imgurl" alt="" />
                        </div>
                        <div class="cont_div left">
                            <h3 class="title">{{item1.title}}</h3>
                            <span class="publishTime">{{item1.publishTime}}</span>
                        </div>
                    </div>
                    </a>
                </li>
                <li style="text-align: center;cursor:pointer" @click="more">点击加载更多...</li>
            </ul>
        </div>
    </div>
    <div id="footer" style="">
      <p>Copyright © 2018-2022 中广在线(北京)网络科技有限公司 All Rights Reserved.网站备案/许可证号:<span style="cursor:pointer;" @click="icpbeiAn()">京ICP备19011357号-5</span></p>
        <!-- <p><img src="../../static/img/BeianIcon.png" alt="">京公网安备 11010602006775号</p> -->
    </div>
</div>

</template>
<script>
export default {
    name:'qvKancn',
    data(){
        return{
            checkChannelId: '',
            arr:[],
            brr:[],
            refreshNum:0,
        }
    },
    methods:{
        more:function(){
            this.loadContent();
        },
        icpbeiAn(){
          window.open("https://beian.miit.gov.cn");
        },

        loadChannel: function () {
          let ishttps = 'https:' == document.location.protocol ? true: false;
          let apiUrl = process.env.API_URL;
          if(ishttps){
            apiUrl = process.env.API_URL_HTTPS;
          }
           this.$http.get(apiUrl+'/getChannel.do').then(resp=> {
             //    this.$http.get('/api/getChannel.do').then(resp=> {
                //  console.log(resp);
              let channelList = resp.body.data;
              for(let i in channelList){
                  if(i==0){
                  this.checkChannelId = channelList[i].id;
                }
                this.arr.push({
                  id:channelList[i].id,
                  name:channelList[i].name
                });
              }
            });

        },

        loadContent:function(refresh){
          this.finishLoad = false;
        //   this.getUserId();
          let userId = this.userId;
          if(!userId || userId ===''){
            userId = '';
          }
          let ishttps = 'https:' == document.location.protocol ? true: false;
          let apiUrl = process.env.API_URL;
          if(ishttps){
            apiUrl = process.env.API_URL_HTTPS;
          }
          this.$http.get(apiUrl+'/getNews.do?channelId='+this.checkChannelId+'&userId='+userId
            ).then(resp=> {
                // console.log(resp);
            let datalist = resp.body.data;
            console.log(datalist);
            if(refresh){
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
                this.brr = [];
            }
            for(let j in datalist){
                var date = new Date(datalist[j].createTime*1);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
                var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' '
                var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':'
                var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':'
                var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
                this.brr.push({
                    imgurl:datalist[j].layouts[0].images[0].url,
                    id:datalist[j].messageId,
                    title:datalist[j].title,
                    clickUrl:datalist[j].shareLink,
                    publishTime: Y+M+D
                })
            }
            console.log(this.brr)
          });
        },
        jumpToDetail:function(url,id){
          this.monitorLg(2,id);
          //window.location.href = url;
          this.$router.push({ name: 'NewsDetailPage', query: { url: url,cid:this.checkChannelId } })
        },
        monitorLg:function(type,messageId){
          let ishttps = 'https:' == document.location.protocol ? true: false;
          let apiUrl = process.env.API_URL;
          if(ishttps){
            apiUrl = process.env.API_URL_HTTPS;
          }
          this.$http.post(apiUrl+'/lg.do',
            {
              userId:this.userId,
              channelId:this.checkChannelId,
              messageId:messageId,
              type:type
            }
            //  this.$http.get('/api/getNews.do?channelId='+this.checkChannelId
          );
        },
        transChannel:function (id) {
          this.checkChannelId = id;
        },
        getList(){
          this.loadContent(true);
        },
    },
    mounted:function(){
        this.loadChannel();
        this.getList();
    },
    created(){
        let that = this;
        window.onscroll = function(){
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
        //变量windowHeight是可视区的高度
        var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        //变量scrollHeight是滚动条的总高度
        var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
            //滚动条到底部的条件
            if(scrollTop+windowHeight==scrollHeight){
                //写后台加载数据的函数
            console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
            // that.loadContent();
            }
        }
    },
    watch:{
        checkChannelId:function () {
          this.loadContent(true);
        },
    }
}
</script>
<style scoped>
*{
    margin: 0;
    padding: 0;
}
body{
    margin: 0;
    padding: 0;
}
a{
    text-decoration:none
}
ul>li{
    list-style: none;
    overflow:hidden;
}
.left{
    float: left;
}
.right{
    float: right;
}
.lf{
    /* position:fixed; */
    background: #fff;
    z-index: 999;
}
.ri{
    margin-left: 20px;
}
.ri_li{
    width: 800px;
    height:120px;
    margin-bottom:10px;
    border-bottom: 1px solid #eee;
}
.clearFix:after{
    content:'';
    display: block;
    clear: both;
}
#container{
    width: 1000px;
    margin: 10px auto;
    margin-top: 70px;
}
#header{
    width: 100%;
    height: 60px;
    background: #e4a75b;
    position:fixed;
    top:0;
    z-index: 999;
}
#footer{
    text-align: center;width:100%;height:40px;background: #e4a75b;font-size: 12px;z-index:999;
    line-height: 40px;
}
#logo_div{
    width: 1200px;
    margin: 0 auto;
    /* line-height: 80px; */
}
.title,.publishTime{
    color:#484848;
}
#logo_div img{
    width: 55px;
    margin-top:2px;
    vertical-align: center;
}
.nav_li{
    display: block;
    width: 160px;
    height: 52px;
    line-height: 52px;
    text-align: center;
    color: #444;
    border-radius: 4px;
    margin-bottom: 2px;
    cursor: pointer;
}

.active{
    color: white;
    background: #e4a75b;
}
.img_div{
    width:180px;
}
.img_div img{
    width:100%;
    height: 100px;
}
.cont_div{
    margin-left: 20px;
    position:relative;
}
.cont_div span{
    position:absolute;
    top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/view/qvKancn.vue